
export interface IMSALAccessToken {
  cachedAt: string,
  clientId: string,
  credentialType: string,
  environment: string,
  expiresOn: string,
  extendedExpiresOn: string,
  homeAccountId: string,
  realm: string,
  secret: string,
  target: string,
  tokenType: string,
  Bearer: string
}

const getMSALCache = (
  cacheName: string = 'accesstoken',
  scope: string = 'default',
): null | IMSALAccessToken => {
  const cacheKey: string | undefined = Object.keys(sessionStorage).find(
    (key) => key.includes(cacheName) && key.includes(scope),
  )
  if (cacheKey) {
    const cacheContent: string | null = sessionStorage.getItem(cacheKey)
    if (cacheContent) {
      const content: IMSALAccessToken = JSON.parse(cacheContent)
      return content
    }
  }
  return null
}
/*
const setMSALCache = (
  cacheName: string = 'accessToken',
  scope: string = 'default',
  content: string,
) => {
  const cacheKey = `${cacheName}-${scope}`
  sessionStorage.setItem(cacheKey, JSON.stringify(content))
}
*/
export { getMSALCache }
